import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

/**
 * Dynamically loads the Infolinks ad scripts.
 * Only injects scripts for unauthenticated, free-tier, and standard_with_ads users.
 * Paid subscribers (standard, premium) see no ads.
 */
export function InfolinksAds() {
  const { hasAds } = useAuth();

  useEffect(() => {
    if (!hasAds) return;

    // Set Infolinks global config
    (window as any).infolinks_pid = 3443874;
    (window as any).infolinks_wsid = 0;

    // Avoid injecting the script more than once
    if (document.getElementById('infolinks-script')) return;

    const script = document.createElement('script');
    script.id = 'infolinks-script';
    script.type = 'text/javascript';
    script.src = '//resources.infolinks.com/js/infolinks_main.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      const existing = document.getElementById('infolinks-script');
      if (existing) existing.remove();
    };
  }, [hasAds]);

  return null;
}
